import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardFooter, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";

import CustomPagination from "components/CustomPagination";
import IconButton from "components/IconButton";
import projetoService from "services/ProjetoService";
import comboService from "services/ComboService";
import AppContext from "AppContext";
import { PapelEnum } from "services/PerfilService";

export default function Projetos() {
  const { state } = useContext(AppContext)
  const [contratos, setContratos] = useState([])
  const [idContrato, setIdContrato] = useState(state.user.perfil.idTipo == PapelEnum.FISCAL && state.contrato ? state.contrato.id : null)
  const [pagina, setPagina] = useState(1)
  const [termo, setTermo] = useState(null)
  const [paginas, setPaginas] = useState(0)
  const [items, setItems] = useState([])
  const navigate = useNavigate()

  const carregar = async () => {
    if (state.user.perfil.idTipo == PapelEnum.FISCAL && !idContrato)
      return

    const res = await projetoService.get(termo, idContrato, pagina)
    if (res.success) {
      setItems(res.data.items)
      setPaginas(res.data.paginas)
    }
  }

  useEffect(() => {
    if (!state.user)
      return

    if (state.user.perfil.idTipo != PapelEnum.FISCAL) {
      comboService.contrato().then(res => {
        if (res.success)
          setContratos(res.data)
      })
    }
  }, [state.contrato])

  useEffect(() => {
    carregar()
  }, [pagina])

  const handleSubmit = e => {
    e.preventDefault()
    setPagina(1)
    carregar()
  }

  return (
    <>
      <Container fluid>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h1 className="my-4">Projetos</h1>
          {/* <Link className="btn btn-primary btn-icon" to="/admin/projetos/0">Incluir</Link> */}
        </div>

        <Card className="shadow mb-4">
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Número OS, numenc ou título</Label>
                    <Input type="text" placeholder="Número OS, numenc ou título" value={termo || ''} onChange={e => setTermo(e.target.value)} />
                  </FormGroup>
                </Col>
                {state.user.perfil.idTipo != PapelEnum.FISCAL && (
                  <Col xs={4}>
                    <Label>Contratos</Label>
                    <select
                      className="form-control"
                      value={idContrato || ''}
                      onChange={(ev) => setIdContrato(ev.target.value != '' ? +ev.target.value : undefined)}
                    >
                      <option value="">Selecione o contrato</option>
                      {contratos.map(el => (
                        <option key={el.id} value={el.id}>{el.numero}</option>
                      ))}
                    </select>
                  </Col>
                )}

                <Col className="d-flex align-items-end justify-content-end">
                  <FormGroup>
                    <Button type="submit" color="primary">Buscar</Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card className="shadow">
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Contrato</th>
                <th scope="col">Número OS</th>
                <th scope="col">Numenc</th>
                <th scope="col">Título</th>
                <th scope="col" style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.length == 0 && (
                <tr>
                  <td colSpan={5} className="text-center">Nenhum registro</td>
                </tr>
              )}
              {items.map(el => (
                <tr key={el.id}>
                  <td>{el.contrato}</td>
                  <td>{el.numeroFmt}</td>
                  <td>{el.numenc}</td>
                  <td>{el.titulo}</td>
                  <td className="d-flex flex-row gap-5px">
                    <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => navigate("/admin/projetos/" + el.idOrdemServico)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CardFooter className="py-4">
            <CustomPagination pagina={pagina} paginas={paginas} onChange={setPagina} />
          </CardFooter>
        </Card>
      </Container>
    </>
  )
}